'use es6';

import { Map as ImmutableMap } from 'immutable';
import { OPEN_SOCIAL_COMPOSER, CLOSE_SOCIAL_COMPOSER } from '../actions/actionTypes';
const socialComposerReducer = (state = ImmutableMap({
  open: false,
  params: ImmutableMap()
}), action) => {
  switch (action.type) {
    case OPEN_SOCIAL_COMPOSER:
      {
        return state.merge({
          params: ImmutableMap(action.payload),
          open: true
        });
      }
    case CLOSE_SOCIAL_COMPOSER:
      {
        return state.set('open', false);
      }
    default:
      return state;
  }
};
export default socialComposerReducer;